import React, { useCallback } from 'react'
import { MainLayout } from '../../../../../../shared/components/main-layout/main-layout.component'
import { ConsumerNetIncomeView } from './components/consumer-net-income-view/consumer-net-income-view.component'
import { ConsumerNetIncomeStepProps } from './consumer-net-income-step.props'

export const ConsumerNetIncomeStep = (props: ConsumerNetIncomeStepProps) => {
  const onComplete = () => props.onComplete(props.step)

  const goBack = useCallback(() => {
    props.goBack(props.step)
  }, [props.step, props.goBack])

  return (
    <MainLayout goBack={props.goBack} step={props.step} hideFooter>
      <ConsumerNetIncomeView
        onComplete={onComplete}
        goBack={goBack}
        step={props.step}
      />
    </MainLayout>
  )
}
